import './index.scss'
import '@fortawesome/fontawesome-free/js/all';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";

import Page404 from './pages/page404';
import PageRating from './pages/pageRating';
import PageFeedback from './pages/pageFeedback';
import PageLayout from './pages/pageLayout';
import PageUnsubscribe from './pages/pageUnsubscribe';
import PageHome from './pages/pageHome';

Sentry.init({
    dsn: "https://b5a52b8778c99a4c28127fe7820df689@o4504876620644352.ingest.us.sentry.io/4509560943607808",
    sendDefaultPii: true
});

createRoot(document.getElementById("root"))
    .render(
        <BrowserRouter>
            <Routes>
                {/* =============== Unsubscribe =============== */}
                <Route path="/" element={<PageHome />} />
                <Route path="/unsubscribe/:guid" element={<PageUnsubscribe />} />
                {/* =============== Layout =============== */}
                <Route element={<PageLayout />}>
                    {/* =============== Review =============== */}
                    <Route path="/rating/:locationId" element={<PageRating />} />
                    <Route path="/feedback/form/:guid/:pForm" element={<PageFeedback />} />
                    <Route path="/feedback/:guid" element={<PageFeedback />} />
                    <Route path="/feedback/:guid/:rating" element={<PageFeedback />} />
                    {/* =============== Other Pages =============== */}
                    <Route path="/rating" element={<Page404 />} />
                    <Route path="/feedback" element={<Page404 />} />
                    <Route path="/404" element={<Page404 />} />
                    <Route path="*" element={<Page404 />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
